import type { PayloadAction } from '@reduxjs/toolkit';

import { buildCreateSlice } from '@reduxjs/toolkit';

import { AlertDataType, AlertState, AlertVariantType } from '@widgets/AlertModal/model/types/alertState';

const createAppSlice = buildCreateSlice({});

const initialState: AlertState = {
  isOpen: false,
  variant: 'success',
  data: {
    title: '',
    text: ''
  }
};

export const alertSlice = createAppSlice({
  name: 'alert',
  initialState,
  reducers: (create) => ({
    openAlert: create.reducer(
      (
        state,
        action: PayloadAction<{
          data: AlertDataType;
          variant?: AlertVariantType;
        }>
      ) => {
        state.isOpen = true;
        state.data = action.payload.data;
        if (action.payload.variant) {
          state.variant = action.payload.variant;
        }
      }
    ),
    closeAlert: create.reducer((state) => {
      state.isOpen = false;
    })
  })
});

export const { openAlert, closeAlert } = alertSlice.actions;

export const alertReducer = alertSlice.reducer;
